// Basic
import PropTypes from 'prop-types';
// Components
import HistoryCard from './HistoryCard';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import TRANSACTION_TYPES from '@/app/modules/terminals/enums/TransactionType';
import rentalFilesFields from '../../../fields/rentalFilesFields';
import { reformatRentalEvents } from '../../../utils/ReformatRentalEvents';
// Lang
import { nsRentalFile } from '@/app/i18n/namespaces';

/**
 * @param {Object} root0
 * @param root0.rentalFile
 * @returns {JSX} RentalFileHistoryPanel
 */
const RentalFileHistoryPanel = ({ rentalFile }) => {

    // Constants
    const rentalEvents = reformatRentalEvents(rentalFile?.[rentalFilesFields.RENTAL_EVENTS.key] ?? []);

    return (
        <div className='flex flex-wrap gap-8 py-3'>
            {rentalEvents.length > 0 ?
                <>
                    {rentalEvents.map((event) =>
                        event.transactionType !== TRANSACTION_TYPES.DEBIT_REVERSAL.name && (
                            <HistoryCard
                                key={event.uuid}
                                rentalEvent={event}
                                isExpired={rentalFile?.isExpired}
                            />
                        ))
                    }
                </>
                :
                <div className='text-center italic w-full p-4 text-muted-foreground'>
                    <Entity
                        entity='history.empty_results'
                        namespace={nsRentalFile}
                    />
                </div>
            }
        </div>
    );
};

RentalFileHistoryPanel.propTypes = {
    rentalFile: PropTypes.object.isRequired
};

export default RentalFileHistoryPanel;